import React from "react"
import queryString from "query-string"

interface YoutubeVideoProps {
  caption: string
  url: string
}

const YoutubeVideo = ({
  node: { caption, url },
}: {
  node: YoutubeVideoProps
}) => {
  const videoParams = queryString.parse(url.split("?")[1])
  return (
    <div className="flex justify-center flex-col items-center">
      <iframe
        className="w-auto sm:w-295px sm:h-auto md:w-560px md:h-315px"
        src={`https://www.youtube.com/embed/${videoParams.v}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
      {!!caption && (
        <p className="text-sm text-center text-gray-600">{caption}</p>
      )}
    </div>
  )
}

export default YoutubeVideo
